//event-bus.vue
import Vue from 'vue';
import VueRouter, { RouterMode } from 'vue-router';
//import { Component, Mixin, Mixins } from 'vue-mixin-decorator';

export class EventBus extends Vue {

    public setTitulo( titulo: string ) {
        this.$emit( 'toolbar-mostrar' );
        this.$emit( 'toolbar-titulo', titulo );
    }

    public ocultarToolbar()
    {
        this.$emit( 'toolbar-ocultar');
    }

    public setQuery( router: VueRouter, query: string ) {
        router.replace( `${router.currentRoute.path}?${query}` ).catch( () => { } );
    }

    public Notificaciones: Notificacion = new Notificacion();
    public Mensajes: Mensaje = new Mensaje();
    public Teclas( e: any ) { this.$emit( 'key', e.key ); }

    public Scroll( e: any ) {

        this.ScrollTop = e.target.documentElement.scrollTop;
        this.OffsetY = e.target.documentElement.scrollHeight - e.target.documentElement.clientHeight;
        this.PorcentajeY = ( this.OffsetY > 0 ? this.ScrollTop / this.OffsetY : 0 ) * 100;

        if ( this.ScrollTop == this.OffsetY ) this.$emit( 'scroll-end' );
        if ( this.ScrollTop == 0 ) this.$emit( 'scroll-top' );
        this.$emit( 'scroll-y', this.PorcentajeY );

    }

    public ScrollBottom( tipo: 'auto' | 'smooth' = 'auto' ) {
        this.$nextTick( () => {
            this.$emit( 'scroll-bottom', tipo );

        } );
    }

    public ElementScrollBottom( element: HTMLElement, tipo: 'auto' | 'smooth' = 'auto' ) {
        if ( element ) {
            element.scrollTo( {
                left: 0,
                top: element.scrollHeight - element.clientHeight,
                behavior: tipo
            } );
        }
    }

    public ElementScrollTop( element: HTMLElement, tipo: 'auto' | 'smooth' = 'auto' ) {
        if ( element ) {
            element.scrollTo( {
                left: 0,
                top: 0,
                behavior: tipo
            } );
        }
    }

    public ScrollTop: number = 0;
    public OffsetY: number = 0;
    public PorcentajeY: number = 0;
    public get Top(): boolean {
        return this.ScrollTop == 0;
    }

    public get End(): boolean {
        return this.ScrollTop == this.OffsetY;
    }
}

export class Mensaje {

    public async SiNo( Titulo: string = "", Mensaje: string = "¿Continuar?", Si: string = "Si", No: string = "Cancelar", MensajeAyuda: string = "" ): Promise<boolean> {
        throw new Error( 'Method not implemented.' );
    };


}

export class Notificacion implements e {

    Error( Mensaje: string ): void {
        throw new Error( 'Method not implemented.' );
    } Completado( Mensaje: string ): void {
        throw new Error( 'Method not implemented.' );
    }
    Info( Mensaje: string ): void {
        throw new Error( 'Method not implemented.' );
    }
    Alerta( Mensaje: string ): void {
        throw new Error( 'Method not implemented.' );
    }



}

interface e {
    Error( Mensaje: string ): void;
    Completado( Mensaje: string ): void;
    Info( Mensaje: string ): void;
    Alerta( Mensaje: string ): void;
}